export default "__VITE_ASSET__R0Gt7PnF__"